/**
 * The diaspora section's regional glow — a stylized silhouette, not a
 * cartographic map. The landmass shape is a soft abstraction (no state
 * borders, no claimed coastline accuracy); the four points are the same
 * cities `landing.diasporaLine3` already names in prose, so the visual adds
 * nothing the copy hasn't already committed to.
 */
const REGIONS = [
  { key: 'newYork', label: 'New York / NJ', x: 302, y: 148 },
  { key: 'california', label: 'California', x: 62, y: 196 },
  { key: 'toronto', label: 'Toronto', x: 246, y: 96 },
  { key: 'vancouver', label: 'Vancouver', x: 66, y: 78 },
];

export default function RegionMap() {
  return (
    <svg className="region-map" viewBox="0 0 380 260" role="img" aria-hidden="true">
      <path
        className="region-map__land"
        d="M55,55 C130,15 260,10 320,55 C365,88 350,150 310,180
           C280,215 230,245 175,250 C120,258 70,225 45,190
           C15,150 10,95 55,55 Z"
      />
      {REGIONS.map((region, index) => (
        // Staggered by index, not randomly, so the halos settle into a
        // fixed, repeatable rhythm rather than a different one per render.
        <g key={region.key} className="region-map__pin" style={{ '--pin-delay': `${index * 0.6}s` }}>
          <circle className="region-map__halo" cx={region.x} cy={region.y} r="14" />
          <circle className="region-map__dot" cx={region.x} cy={region.y} r="4" />
          <text
            className="region-map__label"
            x={region.x}
            y={region.y - 12}
            textAnchor={region.x > 190 ? 'end' : 'start'}
          >
            {region.label}
          </text>
        </g>
      ))}
    </svg>
  );
}
